import React from 'react';

import { CachedImage } from '@common/ui/CachedImage';

import styles from './Result.module.scss';

export interface ResultProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > {
  icon?: React.ReactNode;
  src?: string;
  title: string;
  description?: string | React.ReactNode;
  button?: React.ReactNode;
  size?: 500 | 600;
  iconContainerBg?: string;
}

export const Result: React.FC<ResultProps> = ({
  icon,
  src,
  title,
  description,
  button,
  size = 600,
  iconContainerBg,
  className,
  ...props
}) => {
  return (
    <div
      {...props}
      className={`${styles.result} ${className || ''}`}
      data-size={size}
      data-test-id={`result-container-${size}`}
    >
      <div
        className={styles.iconContainer}
        style={{ backgroundColor: iconContainerBg }}
        data-test-id="result-icon-container"
      >
        {icon && (
          <div className={styles.icon} data-test-id="result-icon">
            {icon}
          </div>
        )}

        {src && (
          <CachedImage
            className={styles.image}
            src={src}
            alt="result-image"
            testId="result-cached-image"
          />
        )}
      </div>

      <div className={styles.title} data-test-id="result-title">
        {title}
      </div>

      {description && (
        <div className={styles.description} data-test-id="result-description">
          {description}
        </div>
      )}

      {button && (
        <div className={styles.buttonContainer} data-test-id="result-button">
          {button}
        </div>
      )}
    </div>
  );
};

Result.displayName = 'Result';
